import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import deepEqual from 'www/vue_components/common/TheFilters/doctors/functions/deepEqual'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const filtersModel: Filters = {
  speciality: {
    id: 0,
    name: '',
    translit: '',
    children: undefined,
    adult: undefined,
  },
  otherSpeciality: undefined,
  disease: undefined,
  city: undefined,
  price: {
    from: undefined,
    to: undefined,
  },
  experience: undefined,
  gender: undefined,
  category: undefined,
  science: undefined,
  patientAge: undefined,
  sort: undefined,
  dateRange: undefined,
  timesOfDay: undefined,
  place: undefined,
  isHighRating: undefined,
  isOnlineAppointment: undefined,
  isClubAppointment: undefined,
  visitLocation: 'clinic',
}

const useFiltersStore = defineStore('filtersStore', () => {
  const filters = ref<Filters>(filtersModel) // Содержит актуальные (сохранённые) фильтры
  const unsavedFilters = ref<Filters>(filtersModel) // Содержит локально изменённые (не сохранённые) фильтры, до их применения
  const isLoading = ref(false)

  const updateUnsavedFilters = (newUnsavedFilters: Partial<Filters>) => {
    unsavedFilters.value = { ...unsavedFilters.value, ...newUnsavedFilters }
  }
  const resetUnsavedFilters = () => {
    unsavedFilters.value = filters.value
  }
  const hasUnsavedFilters = computed(() => (
    !deepEqual(
      JSON.parse(JSON.stringify(unsavedFilters.value)),
      JSON.parse(JSON.stringify(filters.value)),
    )
  ))

  const applyUnsavedFilters = () => {
    filters.value = unsavedFilters.value
  }

  const updateFilters = (newFilters: Partial<Filters>) => {
    filters.value = { ...filters.value, ...newFilters }

    resetUnsavedFilters()
  }

  const updateLoading = (value: boolean) => {
    isLoading.value = value
  }

  return {
    isLoading,
    filters,
    unsavedFilters,
    hasUnsavedFilters,
    updateFilters,
    updateUnsavedFilters,
    resetUnsavedFilters,
    applyUnsavedFilters,
    updateLoading,
  }
})

export default useFiltersStore
